module.exports = __webpack_public_path__ + "static/media/Amichay.00efbefc.jpg";